'use client';
import React from 'react';
import { CategoryEventsSection } from './components';
import useCategoryList from './hooks/categoryList.hook';

const CategoryList = ({
  categoryCode,
  initialData,
  initialEventCategoryName,
}: {
  categoryCode: string;
  initialData?: any[];
  initialEventCategoryName?: string;
}) => {
  const { data, eventCategoryName, refreshing, loading, hasMore, loadMore } =
    useCategoryList(categoryCode, initialData, initialEventCategoryName);
  return (
    <CategoryEventsSection
      data={data}
      loading={loading}
      refreshing={refreshing}
      hasMore={hasMore}
      loadMore={loadMore}
      title={eventCategoryName || 'All Events'}
      subTitle={'Explore what’s going on around you!'}
      message={
        "World Is Full Of Excitement, And You've Explored Just A Fraction Of What We Have To Offer. Keep Exploring For Other Exciting Events."
      }
    />
  );
};

export default CategoryList;
